import { FinancialYearHeaderDDL } from "./CommonDDL/FinancialYearHeaderDDL"
import { MonthHeaderDDL } from "./CommonDDL/MonthHeaderDDL"
import { WardnameHeaderDDL } from "./CommonDDL/WardnameHeaderDDL"


export const DashboardHeaderBar = ({
    // project type tabs
    M_ProjectTypeID,
    DashProjectTypeId,
    setDashProjectTypeId,
    RoleID,
    tabs, // optional custom tabs array, else default list used

    // DDL props
    FinancialYear,
    setFinancialYear,
    Month,
    setMonth,
    WardName,
    setWardName,
    ProjectTypeId,
}) => {

    // default tab list — override by passing `tabs` prop if needed
    const defaultTabs = [
        { id: "5", label: "Official Visit", show: RoleID == 2 },
        { id: "6", label: "Distribution Line", show: true },
        { id: "9", label: "T T P", show: true },
        { id: "1", label: "Main Feeder", show: true },
        { id: "7", label: "WTP Dashboard", show: true },
    ]

    const tabList = (tabs || defaultTabs).filter(tab => tab.show !== false)

    return (
        <div className="row bg-white m-0 p-0 master_border mb-3 align-items-center">

            {/* LEFT SIDE - Buttons */}
            <div className="col-lg-6 col-md-6 col-12 tabws mb-md-2 pe-lg-2">
                {(M_ProjectTypeID == '0') && (
                    <div
                        className="btn-group mt-2"
                        role="group"
                        aria-label="Basic outlined example"
                        style={{ border: '1px solid #001313', borderRadius: '5px' }}
                    >
                        {tabList.map((tab, index) => (
                            <button
                                key={tab.id}
                                onClick={() => setDashProjectTypeId(tab.id)}
                                className={DashProjectTypeId === tab.id ? "btn px-4 activebutton text-white" : "text-black btn px-4"}
                                style={
                                    index !== 0
                                        ? { borderLeft: '1px solid #001313', borderRight: index !== tabList.length - 1 ? '1px solid #001313' : 'none' }
                                        : {}
                                }
                                type="button"
                            >
                                {
                                    tab?.id == 9 ?
                                        <span style={{ whiteSpace: 'nowrap' }}>{tab.label}</span>
                                        :
                                        <span>{tab.label}</span>
                                }
                            </button>
                        ))}
                    </div>
                )}
            </div>

            {/* RIGHT SIDE - DDLs */}
            <div className="col-lg-6 col-md-6 col-12 ms-auto d-flex align-items-center justify-content-end flex-wrap gap-3 pe-3 pt-2">
                <FinancialYearHeaderDDL
                    FinancialYear={FinancialYear}
                    setFinancialYear={setFinancialYear}
                />
                <MonthHeaderDDL
                    Month={Month}
                    setMonth={setMonth}
                />
                <WardnameHeaderDDL
                    WardName={WardName}
                    setWardName={setWardName}
                    M_ProjectTypeID={DashProjectTypeId}
                />
            </div>

        </div>
    )
}